const plans = [
  {
    label: "少量・単身向け",
    name: "軽トラック",
    price: "20,000",
    unit: "円〜",
    size: "軽トラック 1台分",
    volume: "約1〜1.5畳分",
    fits: [
      "1Kのお部屋の片づけ",
      "冷蔵庫＋洗濯機など家電数点",
      "粗大ゴミの一括処分",
    ],
    highlight: false,
  },
  {
    label: "ファミリー・遺品整理",
    name: "2トントラック積み放題",
    price: "35,000",
    unit: "円〜",
    size: "2トントラック 1台分",
    volume: "約3〜4畳分",
    fits: [
      "1LDK〜2DKの片づけ",
      "遺品整理の一括対応",
      "引越しに伴う不用品処分",
    ],
    highlight: false,
  },
  {
    label: "戸建て・法人向け",
    name: "4トントラック積み放題",
    price: "50,000",
    unit: "円〜",
    size: "4トントラック 1台分",
    volume: "約6〜8畳分",
    fits: [
      "戸建てまるごと片づけ",
      "ゴミ屋敷清掃",
      "オフィス移転・残置物撤去",
    ],
    highlight: false,
  },
];

const campaignTargets = [
  "ご家庭の不用品",
  "店舗・オフィスの片づけ",
  "倉庫・工場の整理",
];

const campaignNotes = [
  "内容物・重量・搬出条件により料金が変動する場合があります。",
  "石膏ボード・コンクリート・土砂・液体・危険物などは別途お見積りとなります。",
];

export default function Pricing() {
  return (
    <section id="pricing" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* ========== Section Header ========== */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            PRICE GUIDE
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            分かりやすい<span className="text-primary-500">明朗料金</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都 不用品回収・京都 遺品整理の目安料金です。
            積載量やお品目により変動しますので、詳細は無料お見積りをご利用ください。
          </p>
        </div>

        {/* ========== Kago Cart Campaign ========== */}
        <div className="mb-12 md:mb-16">
          <div className="rounded-2xl border border-accent-300 bg-background-50 overflow-hidden relative shadow-sm">
            {/* Top accent bar */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-accent-500"></div>

            <div className="p-5 md:p-8 lg:p-10 pt-6 md:pt-9 lg:pt-11">
              {/* Campaign label */}
              <div className="inline-flex items-center gap-2 mb-6 md:mb-8">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs md:text-sm font-bold tracking-widest animate-pulse">
                  <i className="ri-sparkling-2-line text-sm"></i>
                  期間限定キャンペーン
                </span>
              </div>

              {/* Full-width infographic image */}
              <div className="rounded-xl overflow-hidden bg-white border border-background-200 shadow-sm">
                <img
                  src="https://static.readdy.ai/image/9751c2861f77ccab088a483472b903b8/55f1997e5102584df5e0c5b2c158d864.png"
                  alt="かご台車1台 9,000円〜の料金案内インフォグラフィック。少量の不用品回収に最適な量でわかりやすい安心料金。かご台車1台（幅約110cm×奥行約80cm×高さ約170cm、積載量の目安 約1立米（約1㎡）・400kgまで）で9,000円〜（税込）。少量でもOK、追加料金の心配なし、作業前にお見積りを提示。"
                  className="w-full h-auto object-contain"
                  loading="lazy"
                />
              </div>

              {/* CTA Buttons */}
              <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
                <a
                  href="tel:0120024747"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
                >
                  <i className="ri-phone-fill text-lg"></i>
                  電話で無料見積り
                </a>
                <a
                  href="https://lin.ee/xf3zQex"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
                >
                  <i className="ri-line-fill text-lg"></i>
                  LINEで写真見積り
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ========== Existing Plans Grid ========== */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {plans.map((p) => (
            <div
              key={p.name}
              className={`relative rounded-lg overflow-hidden border transition-transform ${
                p.highlight
                  ? "border-primary-500 bg-background-50 md:-translate-y-3"
                  : "border-background-200 bg-background-100"
              }`}
            >
              {p.highlight && (
                <div className="absolute top-0 inset-x-0 py-2 text-center bg-primary-500 text-background-50 text-xs font-bold tracking-wider">
                  人気No.1プラン
                </div>
              )}
              <div className={`p-7 ${p.highlight ? "pt-12" : ""}`}>
                <p className="text-xs font-semibold text-secondary-700 tracking-widest mb-2">
                  {p.label}
                </p>
                <h3 className="text-2xl font-bold text-foreground-950 mb-4">
                  {p.name}
                </h3>
                <div className="flex items-end gap-1 mb-2">
                  <span className="font-mincho text-5xl font-bold text-primary-600">
                    {p.price}
                  </span>
                  <span className="text-foreground-700 text-base pb-2">
                    {p.unit}
                  </span>
                  <span className="text-foreground-500 text-xs pb-2 ml-2">
                    (税込)
                  </span>
                </div>
                <div className="mt-4 pt-4 border-t border-background-200 space-y-2 text-sm text-foreground-700">
                  <div className="flex justify-between">
                    <span className="text-foreground-500">サイズ</span>
                    <span className="font-medium">{p.size}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-foreground-500">積載目安</span>
                    <span className="font-medium">{p.volume}</span>
                  </div>
                </div>
                <ul className="mt-5 space-y-2">
                  {p.fits.map((f) => (
                    <li
                      key={f}
                      className="flex items-start gap-2 text-sm text-foreground-800"
                    >
                      <span className="w-4 h-4 mt-1 flex items-center justify-center text-primary-600">
                        <i className="ri-checkbox-circle-fill"></i>
                      </span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className={`mt-6 w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md font-bold text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    p.highlight
                      ? "bg-primary-500 hover:bg-primary-600 text-background-50"
                      : "bg-background-50 hover:bg-background-200 text-foreground-950 border border-background-300"
                  }`}
                >
                  <i className="ri-chat-quote-line"></i>
                  このプランで相談する
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* ========== Notice Card ========== */}
        <div className="mt-10 p-6 md:p-8 rounded-lg bg-secondary-100 border border-secondary-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
              <i className="ri-information-2-line text-2xl"></i>
            </div>
            <div className="text-sm text-secondary-900 leading-relaxed">
              <p className="font-bold mb-1">料金についてのご注意</p>
              <p>
                上記は京都府内における目安料金です。作業内容・階数・階段作業・時間帯・特殊品目（家電リサイクル対象品、産廃扱いの品など）により追加料金が発生する場合があります。
                お見積り後の追加請求は一切ありませんので、まずはお気軽にお問い合わせください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}